<template>
	<div class="text-center">
	    <v-menu  :close-on-content-click="true" >
	      	<template v-slot:activator="{ on: menu, attrs }">
	        	<v-tooltip bottom>
	         		<template v-slot:activator="{ on: tooltip }">
			            <v-btn
			              	dark
			            	:x-small="isXSmall"
			            	:small="isSmall"
			            	:icon="isIconBtn"
			              	:color="colorField || 'transparent'"
			              	v-bind="attrs"
			              	v-on="{ ...tooltip, ...menu }"
			              	:fab="isFab" 
			              	:block="isBlock"	              	
			            >
	              			<v-icon x-smal v-show="isIcon">mdi-vector-square</v-icon>
	              			<v-input  height="2" v-show="isInput" :messages="renderSelecteds">
	              				<span style="font-size: 10px"> {{ $ml.get('analytic') }} </span>
					        </v-input>
	              			<span v-show="isLabel" > {{  inputField[keyField] ? renderSelecteds : $ml.get('analytic')  }} </span>

	            		</v-btn>
	          		</template>
	          		<span>{{$ml.get("analytic") }} : {{renderSelecteds}}</span>
	        	</v-tooltip>
	      	</template>
	      	<v-list>
	      		<v-list-item-group
			        :multiple="isMultiple"
			        v-model="inputField[keyField]"
			        color="primary"
			        @change="AutoSetInField($event)"
			    >
		        	<v-list-item
			          	v-for="(item, index) in renderList"
			          	:key="index"
			          	:value="valueField ? item[valueField] : item"
		        	>
		          		<v-list-item-title>{{ item.name }}</v-list-item-title>
		        	</v-list-item>
	        	</v-list-item-group>
	      	</v-list>
	    </v-menu>
  	</div>

</template>
<script type="text/javascript">
	export default{
		name : "MenuAnalyticCounter",
		props : ["inputField", "keyField", "isLabel", "isXSmall", "isSmall", "isFab", "isIcon", "colorField", "isMultiple", "isIconBtn", "AutoSetField", "AutoValueField", "isBlock", "isInput", "valueField"],
		data : ()=>({
			loading:false,
			menu:false,						
		}),
		computed:{
			renderList(){
				return this.$store.getters["Analytics/getList"]
			},
			renderSelecteds(){
				return (this.isMultiple? this.inputField[this.keyField].map(x=> x.name) : (this.valueField ? this.inputField[this.keyField] : this.inputField[this.keyField]?.name)) || this.$ml.get("none_selected") 
			}
		},		
		methods:{
			AutoSetInField(item){
				if (this.AutoSetField && item) {
					if (this.AutoValueField && !this.valueField) {
						this.inputField[this.AutoSetField]=item?.[this.AutoValueField] || undefined;
					}else{
						this.inputField[this.AutoSetField]=item;
					}
				}								
			}
		}
	}
</script>